import BaseMapper from '../../BaseMapper';

const EventScheduleUpdateMapper = (data, context) => {
    return data;
};

export default EventScheduleUpdateMapper;
